module.exports = __webpack_public_path__ + "img/04.317a8600.jpg";